import { convertStyle } from "../../../react/react"
import { DomItem } from "../domItem"
import { getCroppingDescription, getCroppingInnerStyle, getCroppingStyle } from "./content"
import { TimelineComponentProps } from "./types"

interface Props extends Pick<TimelineComponentProps, "vm" | "onPointerDown"> {
    cropping: DomItem,
    relativeTop?: number
}

export function SingleCrop({ vm, cropping, onPointerDown, relativeTop }: Props) {

    const innerClassNames = `inner ${cropping.continuousPrev ? 'continuous-prev' : ''} ${cropping.continuousNext ? 'continuous-next' : ''} ${cropping.vm.currentYear ? 'cy' : ''}`

    const style = convertStyle(getCroppingStyle(vm, cropping, relativeTop))
    const innerStyle = convertStyle(getCroppingInnerStyle(vm, cropping))
    const description = getCroppingDescription(vm, cropping, vm.showIds)
    const tooltip = cropping.getTooltip(vm.showIds)

    return (

        <div
            key={cropping.id}
            className={`tl-cropping ${cropping.cssClass} `}
            tabIndex={cropping.tabindex}
            style={style}
            title={tooltip}
            onMouseOver={() => cropping.mouseOver = true}
            onMouseLeave={() => cropping.mouseOver = false}
            onPointerDown={e => onPointerDown(e, cropping)}>

            <div className="content">

                <div className={innerClassNames} style={innerStyle}>

                    <div className="text">
                        <span>
                            {
                                cropping.hasInvalidDates()
                                    ? <i className="fas fa-exclamation-triangle" style={{ color: '#a94442' }} title="This crop has invalid dates, and may not be represented accurrately in the timeline.">
                                    </i>
                                    : null
                            }
                            {description}
                        </span>
                    </div>

                    <div className={`line ${cropping.uncropped ? 'uncropped' : ''}`} style={{ borderColor: cropping.color }}>
                    </div>

                    {
                        !cropping.continuousPrev
                            ? <div className="limit limit-left" style={{ backgroundColor: cropping.color }}></div>
                            : null
                    }

                    {
                        !cropping.continuousNext
                            ? <div className="limit limit-right" style={{ backgroundColor: cropping.color }}></div>
                            : null
                    }

                    {
                        cropping.continuousPrev
                            ? <div className="arrow-next" style={{ backgroundColor: cropping.color }}></div>
                            : null
                    }

                </div>

            </div>

        </div>


    )

}
